module.exports = __webpack_public_path__ + "files/88e4e4df5d80b78cbfb79a243f7d65bc.png";